module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper bodyfont-unauth"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "video-player autoheight"
  }, [_c('div', {
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.currentVideo) ? _c('div', {
    staticClass: "reset-video-width"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.currentVideo.title))]), _vm._v(" "), _c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), (_vm.videoNotFoundFlag) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.currentVideo) ? _c('div', {
    staticClass: "player-content"
  }, [_c('p', {
    staticClass: "video-description"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentVideo.Description) + "\n                    ")]), _vm._v(" "), (_vm.getCorpButtonColor === '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "network-tag": "button",
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via facebook")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via twitter")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via linkedin")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via email")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-envelope cursor",
            attrs: {
              "aria-hidden": "true"
            }
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor !== '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "network-tag": "button",
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "facebook"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via facebook")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            style: ({
              color: '#111111 !important'
            }),
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "twitter"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via twitter")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            style: ({
              color: '#111111 !important'
            }),
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "linkedin"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via linkedin")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            style: ({
              color: '#111111 !important'
            }),
            attrs: {
              "aria-hidden": "true"
            }
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "email"
            }
          }, [_c('span', {
            staticClass: "sr-only"
          }, [_vm._v("Share via email")]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-2x fa-envelope cursor",
            style: ({
              color: '#111111 !important'
            }),
            attrs: {
              "aria-hidden": "true"
            }
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.videoExpert) ? _c('div', {
    staticClass: "profile-content"
  }, [_c('a', {
    attrs: {
      "href": '/expert/' + _vm.videoExpert[0].expertId + '/' + _vm.videoExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.videoExpert[0].small_image,
      "alt": _vm.videoExpert[0].name,
      "title": _vm.videoExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.videoExpert && _vm.videoExpert[0].experties))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "video-text"
  }, [_vm._v("\n                        " + _vm._s(_vm.videoExpert && _vm.videoExpert[0].areasofexpertise) + "\n                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoTag && _vm.videoTag !== 'COMMUNITY') ? _c('h2', [_vm._v("MORE " + _vm._s(_vm.videoTag) + " VIDEOS")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.videoList) ? _c('div', {
    staticClass: "row morevediosrow"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider largeslidesilderplayicon"
  }, _vm._l((_vm.videoList), function(vid) {
    return _c('div', {
      staticClass: "slide-player"
    }, [(_vm.videoList) ? _c('div', {}, [_c('a', {
      staticClass: "nounderline",
      attrs: {
        "href": '/contentvideos/play/' + vid.mediaid + '/' + vid.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()
      }
    }, [_c('img', {
      staticClass: "jw-img",
      attrs: {
        "src": vid.image,
        "alt": vid.title,
        "title": vid.title
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-wrap-title cursor"
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(vid.title))])])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.showComponent) ? _c('h4', [_vm._v("Want more tips ? Sign up today for your free TONE trial!")]) : _vm._e(), _vm._v(" "), (_vm.showComponent) ? _c('div', {
    staticClass: "text-center"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/signup')
      }
    }
  }, [_vm._v("Start Your Free Trial")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redeemCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabContent",
    class: {
      current: true
    },
    attrs: {
      "id": "tabs-1"
    }
  }, [_c('div', {}, [(_vm.categoryVideoList) ? _c('div', {
    staticClass: "row yourFaves"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _vm._l((_vm.categoryVideoList), function(video) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-4 bottom-margin"
    }, [_c('img', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "jw-img",
      attrs: {
        "aria-label": video.title,
        "src": video.image,
        "alt": video.title,
        "title": video.title
      },
      on: {
        "click": function($event) {
          return _vm.triggerLogin(video.mediaid)
        }
      }
    }), _vm._v(" "), _c('p', {
      directives: [{
        name: "a11y-action",
        rawName: "v-a11y-action"
      }],
      staticClass: "text-wrap-title cursor",
      staticStyle: {
        "text-align": "left"
      },
      on: {
        "click": function($event) {
          return _vm.triggerLogin(video.mediaid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-play-circle-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(video.title))])])
  })], 2) : _vm._e()])]), _vm._v(" "), (_vm.showComponent) ? _c('h2', {
    staticClass: "pink-text-headline",
    style: ({
      color: _vm.$a11yInkColor(_vm.getCorpHeadingColor) + ' !important'
    })
  }, [_vm._v(" and many more ...")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "errormessage"
  }, [_vm._v("This video is for Members only. "), _c('br'), _vm._v("\n            Become a member today by starting your Free Trial")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2d26e445", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d26e445"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/LifeContents.vue